export const initializeMatomo = () => {
    return new Promise((resolve) => {
        const idSite = document.querySelector('meta[name="site-id"]')?.content;
        const domains = document.querySelector('meta[name="domains"]')?.content;
        const pUrl = document.querySelector('meta[name="p-url"]')?.content;

        if (!pUrl || !idSite) {
            return resolve();
        }

        const _paq = (window._paq = window._paq || []);

        _paq.push(['setTrackerUrl', pUrl + '/js/']);
        _paq.push(['setRequestMethod', 'POST']);
        _paq.push(['setSiteId', idSite]);
        _paq.push(['trackPageView']);
        _paq.push(['enableLinkTracking']);
        _paq.push(['alwaysUseSendBeacon', false]);
        _paq.push(['disableAlwaysUseSendBeacon', true]);

        if (domains) {
            _paq.push(['setDomains', domains]);
        }

        const g = document.createElement('script');
        g.type = 'text/javascript';
        g.async = true;
        g.defer = true;
        g.src = `${pUrl}/js/p.js`;

        const timeout = setTimeout(() => {
            resolve(); // Resolve the promise if the script doesn't load within the timeout
        }, 5000); // 5 seconds timeout (adjust as needed)

        g.onload = () => {
            clearTimeout(timeout); // Clear the timeout if the script loads successfully
            resolve();
        };

        g.onerror = () => {
            clearTimeout(timeout);
            resolve(); // Resolve on error as well to avoid blocking the app
        };

        const s = document.getElementsByTagName('script')[0];
        s.parentNode?.insertBefore(g, s);
    });
};
